export const SITE_BASE_URL = "https://inboxdoctor.ai";

export const CONSULTATION_BOOKING_LINK =
  "https://calendly.com/inboxdoctor-sales/email-deliverability-consultation";
export const SALES_BOOKING_LINK =
  "https://calendly.com/inboxdoctor-sales/30min";

export const RESTRICTED_DOMAINS = [
  // Gmail
  "gmail.com",
  // Outlook
  "outlook.com",
  "hotmail.com",
  "live.com",
  // Yahoo
  "yahoo.com",
  "ymail.com",
  "rocketmail.com",
  // ProtonMail
  "proton.me",
  "protonmail.com",
  // Zoho
  "zoho.com",
  // GMX
  "gmx.com",
  "gmx.us",
  "gmx.net",
  // AOL
  "aol.com",
  // Mail.com
  "mail.com",
  "email.com",
  "usa.com",
  // Tutanota
  "tutanota.com",
  "tutanota.de",
  "tutamail.com",
  "tuta.io",
  "keemail.me",
  // Yandex
  "yandex.com",
  "yandex.ru",
  "yandex.ua",
  "yandex.kz",
  "yandex.by",
];
